document.addEventListener('DOMContentLoaded', function () {
  var PRICES = {
    money: { current: '$7.99', compare: '$14.99', label: 'GET UPSHIFT MONEY — $7.99', handle: 'upshift-money-tracker', variant: '48688829497585' },
    habits: { current: '$5.99', compare: '$12.99', label: 'GET UPSHIFT HABITS — $5.99', handle: 'upshift-habits-tracker', variant: '48688829137137' },
    bundle: { current: '$9.99', compare: '$22.99', label: 'GET THE BUNDLE — $9.99', handle: 'upshift-bundle-1', variant: '48688829858033' }
  };

  function addBankReadyStyles() {
    if (document.getElementById('UpshiftHalykStyles')) return;
    var style = document.createElement('style');
    style.id = 'UpshiftHalykStyles';
    style.textContent = `
      .ucp-payment-note{grid-column:1/-1;margin-top:2px;padding:10px 12px;border:1px solid rgba(24,49,65,.22);border-radius:9px;background:#fefdf9;color:#60737a;font:600 10px/1.45 "DM Sans",sans-serif}
      .ucp-payment-note a{color:#183141;font-weight:700;text-decoration:underline;text-underline-offset:3px}
      .footer-payment-strip{display:flex;flex-wrap:wrap;align-items:center;gap:8px 16px;margin-top:28px;padding:14px 0 2px;border-top:1px solid rgba(255,255,255,.22);color:#d8e7e0;font-size:.76rem;line-height:1.4}
      .footer-payment-strip strong{color:#ffe273;font:700 .7rem/1.2 "Space Grotesk",sans-serif;letter-spacing:.07em}
      .footer-payment-strip a{color:#fff;text-decoration:underline;text-underline-offset:4px;font-weight:700}
      .uc-shell-footer__bank-payment{grid-column:1/-1;display:flex;flex-wrap:wrap;align-items:center;gap:8px 18px;padding:14px 0 0;border-top:1px solid rgb(24 49 65 / 16%);color:#60737a;font-size:11px}
      .uc-shell-footer__bank-payment strong{color:#183141;font:700 10px/1.2 "Space Grotesk",sans-serif;letter-spacing:.08em}
      .uc-shell-footer__bank-payment a{color:#183141;font-weight:700;text-decoration:underline;text-underline-offset:4px}
      .upshift-checkout-modal{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;padding:22px;background:rgba(11,28,38,.68);backdrop-filter:blur(8px)}
      .upshift-checkout-modal.is-open{display:flex}
      .upshift-checkout-modal__panel{position:relative;width:min(760px,100%);max-height:calc(100dvh - 36px);overflow:auto;border:2px solid #183141;border-radius:18px;background:#fcfaf5;box-shadow:10px 10px 0 rgba(24,49,65,.45)}
      .upshift-checkout-modal__top{position:sticky;top:0;z-index:4;display:flex;align-items:center;justify-content:space-between;gap:16px;padding:15px 18px;border-bottom:1px solid rgba(24,49,65,.16);background:#fcfaf5}
      .upshift-checkout-modal__brand{display:flex;align-items:center;gap:9px;color:#183141;font:700 12px/1 "Space Grotesk",sans-serif;letter-spacing:.08em}
      .upshift-checkout-modal__brand:before{content:"";width:9px;height:9px;border-radius:50%;background:#9fd8c2;box-shadow:0 0 0 3px rgba(159,216,194,.32)}
      .upshift-checkout-modal__close{width:36px;height:36px;display:grid;place-items:center;border:2px solid #183141;border-radius:50%;background:#fff;color:#183141;font:700 20px/1 sans-serif;cursor:pointer}
      .upshift-checkout-modal__body{padding:12px 12px 18px}
      .upshift-checkout-modal__loading,.upshift-checkout-modal__error{padding:38px 20px;text-align:center;color:#183141;font:600 14px/1.5 "DM Sans",sans-serif}
      .upshift-checkout-modal__error{color:#9a2c20}
      #UpshiftStripeMount{min-height:420px}
      body.upshift-checkout-open{overflow:hidden!important}
      @media(max-width:640px){.footer-payment-strip,.uc-shell-footer__bank-payment{align-items:flex-start;flex-direction:column}.upshift-checkout-modal{padding:8px}.upshift-checkout-modal__panel{max-height:calc(100dvh - 16px);border-radius:14px;box-shadow:none}.upshift-checkout-modal__top{padding:12px 14px}.upshift-checkout-modal__body{padding:6px 4px 12px}}
    `;
    document.head.appendChild(style);
  }

  function moveBundleHeading() {
    var bundle = document.querySelector('#bundle');
    if (!bundle || bundle.querySelector(':scope > .bundle-heading')) return;
    var tag = bundle.querySelector('.bundle-copy > .tag');
    if (!tag) return;
    var heading = document.createElement('div');
    heading.className = 'bundle-heading';
    heading.appendChild(tag);
    bundle.prepend(heading);
  }

  function routeProductCtas() {
    var moneyCta = document.querySelector('#systems .product.money > a');
    var habitsCta = document.querySelector('#systems .product.habits > a');
    var bundleCta = document.querySelector('#systems .product.bundle-card > a');
    if (moneyCta) moneyCta.setAttribute('href','/products/upshift-money-tracker');
    if (habitsCta) habitsCta.setAttribute('href','/products/upshift-habits-tracker');
    if (bundleCta) bundleCta.setAttribute('href','/products/upshift-bundle-1');

    var assistantTeaserCta = document.querySelector('#inside .assistant-teaser a');
    var assistantSectionCta = document.querySelector('#assistant .assistant-offer a.button');
    if (assistantTeaserCta) assistantTeaserCta.setAttribute('href','/pages/upshift-assistant');
    if (assistantSectionCta) {
      assistantSectionCta.setAttribute('href','/pages/upshift-assistant');
      assistantSectionCta.removeAttribute('rel');
      assistantSectionCta.removeAttribute('target');
    }

    var insideBuy = document.querySelector('#insideBuyCta');
    if (insideBuy) {
      var selected = document.querySelector('.gallery-tabs button[aria-selected="true"]');
      var kind = selected && selected.dataset && selected.dataset.product === 'habits' ? 'habits' : 'money';
      insideBuy.setAttribute('href','/products/' + PRICES[kind].handle);
    }
  }

  function syncHomepagePrices() {
    function setPrice(selector, data) {
      var cta = document.querySelector(selector);
      if (!cta) return;
      var oldEl = cta.querySelector('.price del');
      var newEl = cta.querySelector('.price strong');
      if (oldEl) oldEl.textContent = data.compare;
      if (newEl) newEl.textContent = data.current;
    }
    setPrice('#systems .product.money > a', PRICES.money);
    setPrice('#systems .product.habits > a', PRICES.habits);
    setPrice('#systems .product.bundle-card > a', PRICES.bundle);

    var insideBuy = document.querySelector('#insideBuyCta');
    if (insideBuy) {
      var selected = document.querySelector('.gallery-tabs button[aria-selected="true"]');
      var kind = selected && selected.dataset && selected.dataset.product === 'habits' ? 'habits' : 'money';
      var label = insideBuy.querySelector('span');
      if (label) label.textContent = PRICES[kind].label;
      insideBuy.href = '/products/' + PRICES[kind].handle;
    }
  }

  var upshiftStripeScriptPromise = null;
  var upshiftEmbeddedCheckout = null;

  function loadUpshiftStripeJs() {
    if (window.Stripe) return Promise.resolve(window.Stripe);
    if (upshiftStripeScriptPromise) return upshiftStripeScriptPromise;

    upshiftStripeScriptPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="https://js.stripe.com/dahlia/stripe.js"]');
      if (existing) {
        existing.addEventListener('load', function () { resolve(window.Stripe); }, { once: true });
        existing.addEventListener('error', function () { reject(new Error('Stripe.js failed to load')); }, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = 'https://js.stripe.com/dahlia/stripe.js';
      script.async = true;
      script.onload = function () { resolve(window.Stripe); };
      script.onerror = function () { reject(new Error('Stripe.js failed to load')); };
      document.head.appendChild(script);
    });

    return upshiftStripeScriptPromise;
  }

  function ensureUpshiftCheckoutModal() {
    var modal = document.getElementById('UpshiftStripeModal');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = 'UpshiftStripeModal';
    modal.className = 'upshift-checkout-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = [
      '<div class="upshift-checkout-modal__panel" role="dialog" aria-modal="true" aria-label="Secure checkout">',
        '<div class="upshift-checkout-modal__top">',
          '<div class="upshift-checkout-modal__brand">SECURE UPSHIFT CHECKOUT</div>',
          '<button class="upshift-checkout-modal__close" type="button" aria-label="Close checkout">×</button>',
        '</div>',
        '<div class="upshift-checkout-modal__body">',
          '<div class="upshift-checkout-modal__loading">Loading secure checkout…</div>',
          '<div id="UpshiftStripeMount"></div>',
        '</div>',
      '</div>'
    ].join('');

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('upshift-checkout-open');

      if (upshiftEmbeddedCheckout) {
        try {
          if (typeof upshiftEmbeddedCheckout.destroy === 'function') upshiftEmbeddedCheckout.destroy();
          else if (typeof upshiftEmbeddedCheckout.unmount === 'function') upshiftEmbeddedCheckout.unmount();
        } catch (error) {
          console.warn('Failed to clean up embedded checkout', error);
        }
        upshiftEmbeddedCheckout = null;
      }

      var mount = modal.querySelector('#UpshiftStripeMount');
      if (mount) mount.innerHTML = '';
    }

    modal.querySelector('.upshift-checkout-modal__close').addEventListener('click', close);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    document.body.appendChild(modal);
    return modal;
  }

  async function openUpshiftStripeCheckout(sku, plan) {
    var modal = ensureUpshiftCheckoutModal();
    var loading = modal.querySelector('.upshift-checkout-modal__loading');
    var mount = modal.querySelector('#UpshiftStripeMount');

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('upshift-checkout-open');
    if (loading) {
      loading.className = 'upshift-checkout-modal__loading';
      loading.textContent = 'Loading secure checkout…';
      loading.style.display = 'block';
    }
    if (mount) mount.innerHTML = '';

    try {
      var StripeConstructor = await loadUpshiftStripeJs();
      if (!StripeConstructor) throw new Error('Stripe.js is unavailable');

      var configResponse = await fetch('https://api.upshiftcore.com/api/payments/stripe/config', {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit'
      });
      var config = await configResponse.json();
      if (!configResponse.ok || !config.publishableKey) {
        throw new Error(config.error || 'Stripe configuration is unavailable');
      }

      var metaContext;
      try { metaContext = window.UpshiftMeta ? await window.UpshiftMeta.checkoutContext() : undefined; } catch (metaError) {}
      var checkoutResponse = await fetch('https://api.upshiftcore.com/api/payments/stripe/store-checkout-session', {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sku: sku,
          plan: plan,
          lang: 'en',
          metaContext: metaContext
        })
      });
      var metaCheckoutPayload = await checkoutResponse.json();
      if (!checkoutResponse.ok || !metaCheckoutPayload.clientSecret) {
        throw new Error(metaCheckoutPayload.error || 'Unable to start checkout');
      }
      if (!modal.classList.contains('is-open')) return;
      var stripe = StripeConstructor(config.publishableKey);
      upshiftEmbeddedCheckout = await stripe.createEmbeddedCheckoutPage({
        clientSecret: metaCheckoutPayload.clientSecret,
        onComplete: function () {
          if (loading) {
            loading.className = 'upshift-checkout-modal__loading';
            loading.innerHTML = '<strong>Payment successful.</strong><br>Your delivery email is on the way.';
            loading.style.display = 'block';
          }
        }
      });

      if (!modal.classList.contains('is-open')) {
        upshiftEmbeddedCheckout.destroy();
        upshiftEmbeddedCheckout = null;
        return;
      }
      if (loading) loading.style.display = 'none';
      upshiftEmbeddedCheckout.mount('#UpshiftStripeMount');
      try {
        if (modal.classList.contains('is-open') && window.UpshiftMeta) {
          window.UpshiftMeta.checkoutOpened(metaCheckoutPayload, sku);
        }
      } catch (metaError) {}
    } catch (error) {
      console.error('UPSHIFT embedded checkout failed:', error);
      if (loading) {
        loading.className = 'upshift-checkout-modal__error';
        loading.textContent = 'Checkout could not be opened. Please try again.';
        loading.style.display = 'block';
      }
    }
  }

  function patchProductPage() {
    var stage = document.querySelector('.ucp-product-stage');
    if (!stage) return;

    var buy = stage.querySelector('.ucp-buy');
    if (buy) {
      var activePlan = stage.querySelector('[data-ucp-plan].is-active');
      var planName = activePlan ? activePlan.getAttribute('data-ucp-plan') : 'tracker';
      var kind = stage.getAttribute('data-product-kind') || 'money';
      var sku = kind === 'habits' ? 'HABITS' : (kind === 'bundle' ? 'BUNDLE' : 'MONEY');
      var checkoutPlan = planName === 'yearly' ? 'YEARLY' : (planName === 'monthly' ? 'MONTHLY' : 'TRACKER');
      var checkoutUrl = '#purchase';
      var label = buy.querySelector('span:first-child');

      if (buy.tagName.toLowerCase() !== 'a') {
        var anchor = document.createElement('a');
        anchor.className = buy.className;
        anchor.innerHTML = buy.innerHTML;
        if (checkoutUrl) anchor.href = checkoutUrl;
        if (label) anchor.setAttribute('aria-label', label.textContent);
        buy.replaceWith(anchor);
        buy = anchor;
      } else if (checkoutUrl) {
        buy.href = checkoutUrl;
      }

      buy.setAttribute('data-upshift-sku', sku);
      buy.setAttribute('data-upshift-plan', checkoutPlan);
      buy.removeAttribute('data-checkout-pending');
      buy.removeAttribute('aria-disabled');
      buy.style.textDecoration = 'none';

      if (!buy.getAttribute('data-upshift-checkout-bound')) {
        buy.setAttribute('data-upshift-checkout-bound', 'true');
        buy.addEventListener('click', function (event) {
          event.preventDefault();
          openUpshiftStripeCheckout(
            buy.getAttribute('data-upshift-sku') || 'MONEY',
            buy.getAttribute('data-upshift-plan') || 'TRACKER'
          );
        });
      }
    }

    var trust = stage.querySelector('.ucp-trust');
    if (trust) {
      trust.innerHTML = '<span>✓ Digital delivery</span><span>✓ Google Sheets</span><span>✓ Single-user licence</span>';
      if (!stage.querySelector('.ucp-payment-note')) {
        var note = document.createElement('div');
        note.className = 'ucp-payment-note';
        note.innerHTML = 'The final amount and available payment methods are shown before payment confirmation. Digital delivery begins after successful payment confirmation. <a href="/pages/payment-security">Payment security →</a>';
        trust.insertAdjacentElement('afterend', note);
      }
    }
  }

  function patchProductDetails() {
    var section = document.querySelector('.ucpd');
    if (!section) return;
    var remedy = section.querySelector('.ucpd-card--support');
    if (remedy) {
      var title = remedy.querySelector('h3');
      var copy = remedy.querySelector('p');
      if (title) title.textContent = 'DIGITAL PRODUCT REMEDY';
      if (copy) copy.textContent = 'For this digital product, remedy is provided through access restoration, correction, replacement or refund where applicable. If the product is not delivered, the access link does not work, or a material technical defect prevents the intended use described at purchase, contact support. We will first attempt to restore access or provide a corrected or replacement copy and, where appropriate or required by applicable law, process a refund under the Refund Policy.';
    }
    var delivery = section.querySelector('.ucpd-grid .ucpd-card:nth-child(3)');
    if (delivery && !delivery.querySelector('.ucpd-order-proof-note')) {
      var note = document.createElement('p');
      note.className = 'ucpd-small ucpd-order-proof-note';
      note.textContent = 'Keep your order confirmation and use the same purchase email when contacting support. These details are used to verify the order, delivery and access history.';
      delivery.appendChild(note);
    }
  }

  function patchShellFooter() {
    var footer = document.querySelector('.uc-shell-footer__inner');
    if (footer && !footer.querySelector('.uc-shell-footer__bank-payment')) {
      var payment = document.createElement('div');
      payment.className = 'uc-shell-footer__bank-payment';
      payment.innerHTML = '<strong>PAYMENT & SECURITY</strong><span>Secure HTTPS checkout</span><span>Digital products · no physical shipping</span><span>Available payment methods are shown at checkout</span><a href="/pages/payment-security">Payment Security →</a>';
      var bottom = footer.querySelector('.uc-shell-footer__bottom');
      if (bottom) footer.insertBefore(payment, bottom); else footer.appendChild(payment);
    }
  }

  function renderHomepageFooter() {
    var footer = document.querySelector('main#top + footer');
    if (!footer) return;
    footer.className = 'upshift-home-footer';
    footer.innerHTML = `
      <div class="footer-inner">
        <div class="footer-links-grid">
          <div class="footer-brand-block">
            <a class="brand" href="/" aria-label="UPSHIFT CORE home"><img src="https://cdn.shopify.com/s/files/1/0813/9918/5649/files/upshift-core-logo1.png?v=1788539148" alt=""><span>UPSHIFT CORE</span></a>
            <p>Practical Google Sheets systems for clearer money, stronger habits and visible everyday progress.</p>
            <div class="footer-trust" aria-label="Store assurances"><span>Secure checkout</span><a href="/pages/how-to-access">Digital delivery</a><a href="/pages/contact">Customer support</a></div>
          </div>
          <div class="footer-col footer-col-products"><h4>Products</h4><nav aria-label="Footer products"><a href="/products/upshift-money-tracker">Money Tracker</a><a href="/products/upshift-habits-tracker">Habits Tracker</a><a href="/products/upshift-bundle-1">Bundle</a><a href="/pages/upshift-assistant">UPSHIFT Assistant</a></nav></div>
          <div class="footer-col footer-col-explore"><h4>Explore</h4><nav aria-label="Footer explore"><a href="/#systems">Systems</a><a href="/#inside">Closer Look</a><a href="/#assistant">UPSHIFT Assistant</a><a href="/#how">How It Works</a><a href="/#why">Why It Works</a><a href="/#audience">Who It’s For</a><a href="/#faq">FAQ</a></nav></div>
          <div class="footer-col footer-col-support"><h4>Support</h4><nav aria-label="Footer support"><a href="/pages/how-to-access">Digital Delivery / How to Access</a><a href="/pages/contact">Contact</a><a href="https://t.me/upshift_tracker_bot" target="_blank" rel="noreferrer">Telegram · @upshift_tracker_bot</a><a href="/pages/about">About UPSHIFT CORE</a><a href="/pages/payment-security">Payment Security</a></nav></div>
          <div class="footer-col footer-col-legal"><h4>Legal</h4><nav aria-label="Footer legal"><a href="/pages/privacy-policy">Privacy Policy</a><a href="/pages/public-offer">Public Offer</a><a href="/pages/personal-data-protection">Personal Data Protection</a><a href="/pages/terms-of-service">Terms of Service</a><a href="/pages/refund-policy">Refund Policy</a><a href="/pages/payment-security">Payment Security</a><a href="/pages/license-agreement">License Agreement</a><a href="/pages/assistant-subscription-policy">Assistant Subscription Policy</a></nav></div>
        </div>
        <div class="footer-payment-strip" aria-label="Payment and delivery information"><strong>PAYMENT & SECURITY</strong><span>Secure HTTPS checkout</span><span>Digital delivery after successful payment confirmation</span><span>Available payment methods are shown at checkout</span><a href="/pages/payment-security">Review payment security →</a></div>
        <div class="footer-bottom"><span>© ${new Date().getFullYear()} UPSHIFT CORE · Your life, in forward motion.</span><div class="footer-bottom-links"><a href="/pages/privacy-policy">Privacy</a><a href="/pages/terms-of-service">Terms</a><a href="/pages/contact">Support</a></div></div>
      </div>`;
  }

  function watchCloserLook() {
    var inside = document.querySelector('#inside');
    if (!inside) return;
    var sync = function () { window.setTimeout(function () { routeProductCtas(); syncHomepagePrices(); }, 0); };
    document.querySelectorAll('.gallery-tabs button').forEach(function (tab) {
      tab.addEventListener('click', sync);
      new MutationObserver(sync).observe(tab, { attributes: true, attributeFilter: ['aria-selected'] });
    });
  }

  addBankReadyStyles();
  moveBundleHeading();
  routeProductCtas();
  syncHomepagePrices();
  patchProductPage();
  patchProductDetails();
  patchShellFooter();
  renderHomepageFooter();
  watchCloserLook();

  window.setTimeout(function () {
    routeProductCtas();
    syncHomepagePrices();
    patchProductPage();
    patchProductDetails();
    patchShellFooter();
  }, 40);
});

